import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TicketsRoutingModule } from './tickets-routing.module';
import { TicketsViewComponent } from './tickets-view/tickets-view.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { PipeModule } from 'app/shared/pipes/pipe.module';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { QuillModule } from 'ngx-quill';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxSpinnerModule } from 'ngx-spinner';
import { TicketsListComponent } from './tickets-list/tickets-list.component';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { MatMenuModule } from '@angular/material/menu';


@NgModule({
  declarations: [
    TicketsViewComponent,
    TicketsListComponent
  ],
  imports: [
    CommonModule,
    TicketsRoutingModule,
    NgbModule,
    QuillModule.forRoot(),
    FormsModule,
    PerfectScrollbarModule,
    PipeModule,
    ReactiveFormsModule,
    NgSelectModule,
    NgxSpinnerModule,
    NgxDatatableModule,  
    MatMenuModule
  ]
})
export class TicketsModule { }
